var exports = {
  "e": "TransferOwnershipModal.module__warningBox___VlgyZ2",
  "i": "TransferOwnershipModal.module__warningText___VlgyZ2",
};

module.exports = exports;
